import { find } from 'lodash'

import { WPPageData } from '@/types'

export const pageHasHero = (pageProps: WPPageData) => {
  const sections =
    pageProps?.type === 'taxonomy'
      ? pageProps?.object?.acf?.sections
      : pageProps?.acf?.sections || []
  return (
    find(sections, (item) => item?.acf_fc_layout?.startsWith('hero')) !==
    undefined
  )
}
